import React, { createContext, useContext } from "react";

export const CreditSearchContext = createContext("");

export const useCreditSearchQuery = () => useContext(CreditSearchContext);

export const normalizeSearchText = (text) =>
  String(text || "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

export const buildBlockHaystack = (block, credit) => {
  const options = credit?.options || {};
  const items = credit?.items || block?.items || [];
  const parts = [
    block?.block_name,
    block?.heading,
    block?.subheading,
    options.block_name,
    options.heading,
    options.subheading,
  ];
  items.forEach((item) => {
    if (!item) return;
    parts.push(item.name, item.role, item.blurb);
    parts.push(item.song?.title, item.song?.details);
    if (typeof item.song === "string") parts.push(item.song);
    parts.push(item.logo?.title);
  });
  return normalizeSearchText(parts.filter(Boolean).join(" "));
};

export const blockMatchesQuery = (block, credit, query) => {
  if (!query) return false;
  return buildBlockHaystack(block, credit).includes(query);
};

export const highlightSearchText = (text, query) => {
  const source = text == null ? "" : String(text);
  const q = normalizeSearchText(query);
  if (!source) return source;
  if (!q) return source;
  const lowerSrc = source.toLowerCase();
  if (!lowerSrc.includes(q)) return source;
  const out = [];
  let i = 0;
  let n = 0;
  let found = lowerSrc.indexOf(q, i);
  while (found !== -1) {
    if (found > i) out.push(source.slice(i, found));
    out.push(
      <mark className="credit-search-hit" key={`credit-search-${n++}`}>
        {source.slice(found, found + q.length)}
      </mark>,
    );
    i = found + q.length;
    found = lowerSrc.indexOf(q, i);
  }
  if (i < source.length) out.push(source.slice(i));
  return out;
};

export const getFirstMatchingItemText = (block, credit, query) => {
  const q = normalizeSearchText(query);
  if (!q) return null;

  const blockName = block?.block_name || credit?.options?.block_name || "";
  if (normalizeSearchText(blockName).includes(q)) return null;

  const items = credit?.items || block?.items || [];
  for (const item of items) {
    if (item?.name && normalizeSearchText(item.name).includes(q)) return item.name;
    if (item?.role && normalizeSearchText(item.role).includes(q)) return item.role;
  }

  return null;
};

export function SearchHit({ text }) {
  const query = useCreditSearchQuery();
  if (text == null) return null;
  return highlightSearchText(text, query);
}
